// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noBackground[data-v-0b7c3cdc]{background:none!important}", ""]);
// Exports
module.exports = exports;
